import axios from "axios";
import { selector, selectorFamily, useRecoilValue } from "recoil";
import { COMMUNICATE_ERROR_MESSAGE_CUSTOMER_LIST } from "../constants/ErrorMessage";
import { executeLinksAPI } from "../utils/LinksAPI";

// API
// プロファイル選択画面(/select)で使用するプロファイル(user_group, workspace)リスト取得
const _getUserProfile = async (customerCode) => {
  const config = {
    method: 'GET',
  };
  if (customerCode) {
    config.params = {
      customer_code: customerCode,
    }
  }

  return await executeLinksAPI('fosterlinks/user/profile', config);
};

// 選択したプロファイルを設定
const _setUserProfile = async (data) => {
  const config = {
    method: 'POST',
    data: data
  };

  return await executeLinksAPI('fosterlinks/user/profile', config);
};

const _listCustomer = async () => {
  const apiUrl = process.env.REACT_APP_COMMON_API_URL;
  const apiKey = process.env.REACT_APP_COMMON_API_KEY;
  const config = {
    method: 'GET',
    url: `${apiUrl}/common/customer/list`,
    headers: {
      'x-api-key': apiKey
    },
    errorHandle: {
      message: COMMUNICATE_ERROR_MESSAGE_CUSTOMER_LIST
    }
  };

  return await axios(config)
    .then(response => {
      const list = response.data || [];
      return list.sort((a, b) => a.customer_code.localeCompare(b.customer_code));
    }).catch(e => {
      return e;
    });
};

/* ユーザープロファイルselector */
const userProfileQuery = selector({
  key: 'userProfileQuery',
  get: async () => {
    return await _getUserProfile();
  }
});

/* カスタマーリストselector */
const customerListQuery = selector({
  key: 'customerListQuery',
  get: _listCustomer,
});

/* カスタマー別ユーザープロファイルselector */
const userProfileByCustomerQuery = selectorFamily({
  key: 'userProfileByCustomerQuery',
  get: customerCode => () => {
    if (customerCode === '') return {};
    return _getUserProfile(customerCode);
  }
});

export const useUserProfile = () => {
  const userProfile = useRecoilValue(userProfileQuery);

  const setUserProfile = (usergroupId, workspaceId = undefined) => {

    if (!usergroupId) {
      throw new Error('Unset require parameter');
    };

    const profile = {
      usergroup_id: usergroupId
    }
    
    if (workspaceId) {
      profile.workspace_id = workspaceId;
    }

    return _setUserProfile(profile);

  };

  return {
    userProfile,
    setUserProfile
  };
};

export const useCustomerList = () => {
  const customerList = useRecoilValue(customerListQuery);

  return {
    customerList,
  }
}

export const useSelectedUserProfile = customerCode => {
  const userProfile = useRecoilValue(userProfileByCustomerQuery(customerCode));

  return {
    userProfile
  }
}
